// extracted by mini-css-extract-plugin
export default {"container":"EmptyCart_container__KYSAW","text":"EmptyCart_text__sCRoO","image":"EmptyCart_image__mxckP","shopButton":"EmptyCart_shopButton__X8y0A"};